import script from "./CourseModalButtonSettingsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseModalButtonSettingsMenu.vue?vue&type=script&setup=true&lang=js"

import "./CourseModalButtonSettingsMenu.vue?vue&type=style&index=0&id=fdae03a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdae03a2"]])

export default __exports__